import React, { useEffect, useRef, useState } from "react";
import { useDataViewNavBarLayout, useDataViews } from "@me8eon/data_views";
import { useSelectedDataViewName } from "@me8eon/data_view_filter";
import { CatchWidth } from "@me8eon/catch_width";
import { useTranslation } from "@me8eon/translation";
import MoreDropdown from "./more.dropdown";
import DataList from "./data.list";
import "./data.view.nav.bar.scss";
import { Icon } from "@me8eon/icons";

export type DataViewNavBarProps = {
    rootId: string;
    width: number;
};

export const DataViewNavBarChild: React.FC<DataViewNavBarProps> = ({ rootId, width }: DataViewNavBarProps) => {
    const selectedOps = useSelectedDataViewName();
    const DisplayLayout = useDataViewNavBarLayout();
    const dataViews = useDataViews();
    const t = useTranslation();
    const actualData = Object.entries(dataViews);
    const dataViewsLength = actualData.length;
    let moreTextHidden = true;
    const selectedOpsName = selectedOps[0];
    let visibleElems: number = 0;
    let availableWidth: number = width - (48 + 220);

    const widths: number[] = actualData.map(([name]) => {
        const currentText = t(`filterPage.filterMenu.${name}`);
        const currentElemWidth = currentText.length * 9 + 64;
        return currentElemWidth;
    });

    for (let index = 0; index < dataViewsLength; index++) {
        const elementWidth = widths[index];
        availableWidth -= elementWidth;
        if (availableWidth > 0) {
            visibleElems += 1;
            if (actualData[index][0] === selectedOpsName) {
                moreTextHidden = false;
            }
        }
    }

    return (
        <>
            <div className="nav-bar-wrapper">
                <DisplayLayout id={`${rootId}-navbar-container`}>
                    <DataList position="horizontal" visibleElems={visibleElems} rootId={rootId} />
                </DisplayLayout>
                {dataViewsLength > visibleElems ? (
                    <MoreDropdown moreTextHidden={moreTextHidden} menuItemSelected={t(`filterPage.filterMenu.${selectedOpsName}`)}>
                        <DataList maxChars={10} selectedTick={true} position="vertical" visibleElems={visibleElems} rootId={rootId} />
                    </MoreDropdown>
                ) : null}
            </div>
            <div style={{ background: "#f1f1ef", padding: "8px", display: "flex", alignItems: "center", gap: "8px" }}>
                <div style={{ width: "24px" }}>
                    <Icon name="info" />
                </div>
                <span>{t(`filterPage.filterMenu.disclaimer`)}</span>
            </div>
        </>
    );
};
export const DataViewNavBar = CatchWidth(DataViewNavBarChild);
